import React from 'react'

const ITRBalanceSheetUI = ({ balanceSheetList }) =>
    <div id='itrBalanceSheet' className='g_m_top_100'>
        <span className='g_large'><b>Balance Sheet</b></span>
        <table className='g_table'>
            <thead className='g_sticky'><tr><td />
                {
                    balanceSheetList.map((bs, i) =>
                        <td key={i} className='g_text_right'>
                            <b className='g_no_wrap'>{bs.financialYear}</b>
                        </td>
                    )
                }
            </tr></thead>
            <tbody>
                <tr><td colSpan='8'><b>Equity & Liabilities</b></td></tr>
                <RowUI balanceSheetList={balanceSheetList} name='shareCapitalProprietorSCapital' />
                <RowUI balanceSheetList={balanceSheetList} name='totalReservesAndSurplus' />
                <RowUI balanceSheetList={balanceSheetList} name='retainedEarnings' />
                <RowUI balanceSheetList={balanceSheetList} name='moneyReceivedAgainstShareWarrants' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='shareholderSFundsProprietorSFunds' />
                <RowUI balanceSheetList={balanceSheetList} name='shareApplicationMoneyPendingAllotment' />
                <RowUI balanceSheetList={balanceSheetList} name='longTermBorrowingsInBondsDebentures' />
                <RowUI balanceSheetList={balanceSheetList} name='longTermBorrowingsInTermLoans' />
                <RowUI balanceSheetList={balanceSheetList} name='longTermLiabilitiesFromRelatedParties' />
                <RowUI balanceSheetList={balanceSheetList} name='securedLoanFromBanksOthers' />
                <RowUI balanceSheetList={balanceSheetList} name='securedForeignCurrencyLoans' />
                <RowUI balanceSheetList={balanceSheetList} name='unsecuredLoanFromBanksOthers' />
                <RowUI balanceSheetList={balanceSheetList} name='unsecuredForeignCurrencyLoans' />
                <RowUI balanceSheetList={balanceSheetList} name='tradePayablesGreaterThen6Months' />
                <RowUI balanceSheetList={balanceSheetList} name='deferredTaxLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} name='longTermProvisions' />
                <RowUI balanceSheetList={balanceSheetList} name='liabilitiesLongTermLoansAndAdvances' />
                <RowUI balanceSheetList={balanceSheetList} name='otherLongTermLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalNonCurrentLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} name='loansRepayableOnDemandFromBanksOtherParties' />
                <RowUI balanceSheetList={balanceSheetList} name='shortTermLiabilitiesFromRelatedParties' />
                <RowUI balanceSheetList={balanceSheetList} name='currentMaturitiesOfLongTermDebt' />
                <RowUI balanceSheetList={balanceSheetList} name='deferredTaxLiability' />
                <RowUI balanceSheetList={balanceSheetList} name='currentTaxLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} name='tradePayablesLessThen6Months' />
                <RowUI balanceSheetList={balanceSheetList} name='liabilitiesShortTermLoansAndAdvances' />
                <RowUI balanceSheetList={balanceSheetList} name='shortTermProvisions' />
                <RowUI balanceSheetList={balanceSheetList} name='otherCurrentLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalCurrentLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalLiabilities' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalEquityAndLiabilities' />
                <tr><td colSpan='8'><b className='g_m_top_200'>Assets</b></td></tr>
                <RowUI balanceSheetList={balanceSheetList} name='tangibleAssetsGross' />
                <RowUI balanceSheetList={balanceSheetList} name='intangibleAssetsGross' />
                <RowUI balanceSheetList={balanceSheetList} name='capitalWorkInProgress' />
                <RowUI balanceSheetList={balanceSheetList} name='intangibleAssetsUnderDevelopment' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalGrossBlock' />
                <RowUI balanceSheetList={balanceSheetList} name='depreciationAndAmortization' />
                <RowUI balanceSheetList={balanceSheetList} name='impairmentLosses' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalFixedAssets' />
                <RowUI balanceSheetList={balanceSheetList} name='nonCurrentInvestments' />
                <RowUI balanceSheetList={balanceSheetList} name='tradeReceivablesGreaterThen6Months' />
                <RowUI balanceSheetList={balanceSheetList} name='deferredTaxAssets' />
                <RowUI balanceSheetList={balanceSheetList} name='assetsLongTermLoansAndAdvances' />
                <RowUI balanceSheetList={balanceSheetList} name='otherNonCurrentAssets' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalNonCurrentAssets' />
                <RowUI balanceSheetList={balanceSheetList} name='currentInvestments' />
                <RowUI balanceSheetList={balanceSheetList} name='inventories' />
                <RowUI balanceSheetList={balanceSheetList} name='tradeReceivablesLessThen6Months' />
                <RowUI balanceSheetList={balanceSheetList} name='cashAndCashEquivalents' />
                <RowUI balanceSheetList={balanceSheetList} name='assetsShortTermLoansAndAdvances' />
                <RowUI balanceSheetList={balanceSheetList} name='currentTaxAssets' />
                <RowUI balanceSheetList={balanceSheetList} name='otherCurrentAssets' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalCurrentAssets' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='totalAssets' />
                <RowUI balanceSheetList={balanceSheetList} total={true} name='netWorth' />
            </tbody>
        </table>
    </div>

const RowUI = ({ balanceSheetList, total, name }) =>
    <tr className={total && 'g_table_total'}>
        <td><Desc name={name} /></td>
        {
            balanceSheetList.map((bs, i) =>
                <td key={i} className='g_text_right g_m_left_100'>
                    {bs[name]}
                </td>
            )
        }
    </tr>

const Desc = ({ name }) =>
    <span>
        {(() => {
            switch (name) {
                case 'shareCapitalProprietorSCapital':
                    return `Share Capital/Proprietor's Capital`
                case 'totalReservesAndSurplus':
                    return 'Total Reserves and Surplus'
                case 'retainedEarnings':
                    return 'Retained Earnings'
                case 'moneyReceivedAgainstShareWarrants':
                    return 'Money Received against Share Warrants'
                case 'shareholderSFundsProprietorSFunds':
                    return `Shareholder's Funds/Proprietor's Funds`
                case 'shareApplicationMoneyPendingAllotment':
                    return 'Share Application Money Pending Allotment'
                case 'longTermBorrowingsInBondsDebentures':
                    return 'Long Term Borrowings in Bonds/Debentures'
                case 'longTermBorrowingsInTermLoans':
                    return 'Long Term Borrowings in Term Loans'
                case 'longTermLiabilitiesFromRelatedParties':
                    return 'Long Term Liabilities from Related Parties'
                case 'securedLoanFromBanksOthers':
                    return 'Secured Loan from Banks/Others'
                case 'securedForeignCurrencyLoans':
                    return 'Secured Foreign Currency Loans'
                case 'unsecuredLoanFromBanksOthers':
                    return 'Unsecured Loan from Banks/Others'
                case 'unsecuredForeignCurrencyLoans':
                    return 'Unsecured Foreign Currency Loans'
                case 'tradePayablesGreaterThen6Months':
                    return 'Trade Payables (>6 Months)'
                case 'deferredTaxLiabilities':
                    return 'Deferred Tax Liabilities'
                case 'longTermProvisions':
                    return 'Long Term Provisions'
                case 'longTermLoansAndAdvances':
                case 'liabilitiesLongTermLoansAndAdvances':
                case 'assetsLongTermLoansAndAdvances':
                    return 'Long Term Loans and Advances'
                case 'otherLongTermLiabilities':
                    return 'Other Long Term Liabilities'
                case 'totalNonCurrentLiabilities':
                    return 'Total Non-Current Liabilities'
                case 'loansRepayableOnDemandFromBanksOtherParties':
                    return 'Loans Repayable On Demand from Banks/Other Parties'
                case 'shortTermLiabilitiesFromRelatedParties':
                    return 'Short Term Liabilities from Related Parties'
                case 'currentMaturitiesOfLongTermDebt':
                    return 'Current Maturities of Long Term Debt'
                case 'deferredTaxLiability':
                    return 'Deferred Tax Liability'
                case 'currentTaxLiabilities':
                    return 'Current Tax Liabilities'
                case 'tradePayablesLessThen6Months':
                    return 'Trade Payables (<6 Months)'
                case 'shortTermLoansAndAdvances':
                case 'liabilitiesShortTermLoansAndAdvances':
                case 'assetsShortTermLoansAndAdvances':
                    return 'Short Term Loans and Advances'
                case 'shortTermProvisions':
                    return 'Short Term Provisions'
                case 'otherCurrentLiabilities':
                    return 'Other Current Liabilities'
                case 'totalCurrentLiabilities':
                    return 'Total Current Liabilities'
                case 'totalLiabilities':
                    return 'Total Liabilities'
                case 'totalEquityAndLiabilities':
                    return 'Total Equity and Liabilities'

                case 'tangibleAssetsGross':
                    return 'Tangible Assets - Gross'
                case 'intangibleAssetsGross':
                    return 'Intangible Assets - Gross'
                case 'capitalWorkInProgress':
                    return 'Capital Work in Progress'
                case 'intangibleAssetsUnderDevelopment':
                    return 'Intangible Assets under Development'
                case 'totalGrossBlock':
                    return 'Total Gross Block'
                case 'depreciationAndAmortization':
                    return 'Depreciation and Amortization'
                case 'impairmentLosses':
                    return 'Impairment Losses'
                case 'totalFixedAssets':
                    return 'Total Fixed Assets'
                case 'nonCurrentInvestments':
                    return 'Non-current Investments'
                case 'tradeReceivablesGreaterThen6Months':
                    return 'Trade Receivables (>6 Months)'
                case 'deferredTaxAssets':
                    return 'Deferred Tax Assets'
                case 'otherNonCurrentAssets':
                    return 'Other Non-Current Assets'
                case 'totalNonCurrentAssets':
                    return 'Total Non-current Assets'
                case 'currentInvestments':
                    return 'Current Investments'
                case 'inventories':
                    return 'Inventories'
                case 'tradeReceivablesLessThen6Months':
                    return 'Trade Receivables (<6 Months)'
                case 'cashAndCashEquivalents':
                    return 'Cash and Cash Equivalents'
                case 'currentTaxAssets':
                    return 'Current Tax Assets'
                case 'otherCurrentAssets':
                    return 'Other Current Assets'
                case 'totalCurrentAssets':
                    return 'Total Current Assets'
                case 'totalAssets':
                    return 'Total Assets'
                case 'netWorth':
                    return 'Net Worth'
                default:
                    return name
            }
        })()}
    </span>

export default ITRBalanceSheetUI
